import { Component, OnInit, Input } from '@angular/core';
import { ExtendedEventBaseItem } from 'world-archery-lib';
import { CalendarFilterService } from '../../services/calendar-filter.service';
import { HttpClient } from '@angular/common/http';
import { FilesStore } from '../../../../common-page-components/stores/entities-store/files-store';

@Component({
  selector: 'app-calendar-detail',
  templateUrl: './calendar-detail.component.html',
  styleUrls: ['./calendar-detail.component.scss']
})
export class CalendarDetailComponent implements OnInit {

  @Input()
  event: ExtendedEventBaseItem = {} as any;

  /**
   * The docs store for load documents.
   *
   * @memberof CalendarDetailComponent
   */
  docsStore = new FilesStore(this.http);
  constructor(
    public filter_service: CalendarFilterService,
    private http:HttpClient
  ) { }

  ngOnInit() {
    this.docsStore.requestData({CompId: this.event.id}, false).subscribe();
  }

}
